import { render } from "./DatenschutzView.vue?vue&type=template&id=71f440a8&scoped=true"
const script = {}

import "./DatenschutzView.vue?vue&type=style&index=0&id=71f440a8&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-71f440a8"]])

export default __exports__